import { useEffect, useState } from 'react';
import pharmacy from 'services/pharmacy';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as Types from 'helpers/types';

export default () => {
  const [selectedPharmacy, setSelectedPharmacy] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const getSelectedPharmacy = async () => {
      try {
        const response = await pharmacy.get(`/coopuser/selected-pharmacy`);
        setSelectedPharmacy(response.data);
        dispatch({ type: Types.SELECTED_PHARMACY_DETAILS_SET, payload: response.data })
      } catch (e) {
        history.push('/pharmacy/error');      }
    };

    getSelectedPharmacy();
  }, [history]);
  return [selectedPharmacy];
};
